<template>
  <div class="modules-carousel" v-if="modules.length > 0">
    <b-row class="align-items-center">
      <b-col cols="1" class="d-flex justify-content-center align-items-center">
        <button 
          class="nav-arrow"
          :disabled="currentStartIndex === 0"
          @click="prevSlide">
          <i class="fas fa-chevron-circle-left"></i>
        </button>
      </b-col>

      <b-col cols="10">
        <div class="carousel-track-wrapper">
          <div class="carousel-track">
            <div
              class="carousel-item-wrapper"
              v-for="module in visibleModules"
              :key="module.id"
            >
              <ModuleCard
                :moduleNumber="Number(module.number)"
                :moduleTitle="module.name"
                :imageSrc="module.image"
                :isHovered="hoveredModule === Number(module.number)"
                @hoveredModule="handleHoveredModule"
              />
            </div>
          </div>
        </div>
      </b-col>

      <b-col cols="1" class="d-flex justify-content-center align-items-center">
        <button 
          class="nav-arrow"
          :disabled="!hasMoreModules"
          @click="nextSlide">
          <i class="fas fa-chevron-circle-right"></i>
        </button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import ModuleCard from "@/components/academy/ModuleCard.vue";

export default {
  name: "ModulesCarousel",
  props: {
    modules: {
      type: Array,
      required: true,
    },
  },
  components: {
    ModuleCard,
  },
  data() {
    return {
      hoveredModule: 1,
      currentStartIndex: 0,
      visibleCardCount: 4,
    };
  },
  computed: {
    visibleModules() {
      return this.modules.slice(
        this.currentStartIndex, 
        this.currentStartIndex + this.visibleCardCount
      );
    },
    hasMoreModules() {
      return this.currentStartIndex + this.visibleCardCount < this.modules.length;
    }
  },
  methods: {
    handleHoveredModule(moduleNumber) {
      this.hoveredModule = moduleNumber;
      this.$emit("module-select", moduleNumber);
    },
    prevSlide() {
      if (this.currentStartIndex > 0) {
        this.currentStartIndex -= 1;
      }
    },
    nextSlide() {
      if (this.hasMoreModules) {
        this.currentStartIndex += 1;
      }
    },
  },
};
</script>

<style scoped>
.modules-carousel {
  position: relative;
  overflow: hidden;
}

.carousel-track-wrapper {
  overflow: hidden;
  width: 100%;
  padding-top: 20px;
}

.carousel-track {
  display: flex;
  transition: transform 0.5s ease;
}

.carousel-item-wrapper {
  flex: 0 0 25%; /* Ajustar para 4 tarjetas visibles */
  box-sizing: border-box;
  padding: 0 10px; 
}

.nav-arrow {
  background: transparent;
  border: none;
  font-size: 2rem;
  color: #333;
  cursor: pointer;
  transition: color 0.2s;
}

.nav-arrow:disabled {
  color: #ccc;
  cursor: not-allowed;
}

.nav-arrow:hover:not(:disabled) {
  color: #132B77;
}
.nav-arrow {
  background: transparent;
  border: none;
  font-size: 2rem;
  color: #333;
  cursor: pointer;
  transition: color 0.2s;
  padding: 0;  /* Remove any default padding */
}

.nav-arrow i {
  vertical-align: middle;
}

.nav-arrow:disabled i {
  color: #ccc;
  cursor: not-allowed;
}

.nav-arrow:hover:not(:disabled) i {
  color: #132B77;
}
</style>